import IssuerListContainer from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/Sections/IssuerListContainer';
import OneLevelListContainer from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/Sections/OneLevelListContainer';
import RangeContainer from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/Sections/RangeContainer';
import CurrentFaceRangeContainer from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/Sections/CurrentFaceRangeContainer';
import StatusContainer from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/Sections/StatusContainer';
import TwoLevelListContainer from '@/creditflowresearch/ui/components/bonds/common/BondsSidebar/Sections/TwoLevelListContainer';
import Sections from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/Sections';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';

const filtersTitleMapping = {
  status: 'Status',
  sectorList: 'Sectors & Subsectors',
  issuerList: 'Issuers',
  dealerList: 'dealers',
  currentFaceRange: 'Current Face',
  walRange: 'Wal (Years)',
  ratingGroupList: 'Ratings',
  statusList: 'Statuses',
  ratingAgencyList: 'Rating Agencies',
  benchmarkGroupList: 'Benchmark',
  spreadRange: 'Spread',
  speedTypeList: 'Speed Type',
  speedRange: 'Speed',
};

const filtersComponentsMapping = {
  status: {
    component: StatusContainer,
    componentProps: {
      filterName: 'includedStatus',
    },
  },
  sectorList: {
    component: TwoLevelListContainer,
    componentProps: {
      filterName: 'includedSubsectorIds',
      parentKeyPrefix: 'sector',
    },
  },
  dealerList: {
    component: OneLevelListContainer,
    componentProps: {
      filterName: 'includedDealerIds',
      itemKeyPrefix: 'dealer',
      columnsCount: 1,
      labelWithAbbreviation: true,
    },
  },
  issuerList: {
    component: IssuerListContainer,
    componentProps: {
      filterName: 'includedIssuerIds',
    },
  },
  currentFaceRange: {
    component: CurrentFaceRangeContainer,
    componentProps: {
      filterName: 'currentFaceRange',
      step: 1,
      decimals: 0,
      columnsCount: 1,
    },
  },
  walRange: {
    component: RangeContainer,
    componentProps: {
      filterName: 'walRange',
      step: 0.01,
      decimals: 2,
    },
  },
  ratingGroupList: {
    component: OneLevelListContainer,
    componentProps: {
      filterName: 'includedRatingGroupIds',
      columnsCount: 4,
      isAbbreviationInLabel: true,
      itemKeyPrefix: 'ratingGroup',
    },
  },
  ratingAgencyList: {
    component: OneLevelListContainer,
    componentProps: {
      filterName: 'includedRatingAgencyIds',
      labelWithAbbreviation: true,
      itemKeyPrefix: 'ratingAgency',
    },
  },
  benchmarkGroupList: {
    component: OneLevelListContainer,
    componentProps: {
      filterName: 'includedBenchmarkGroupIds',
      itemKeyPrefix: 'benchmarkGroup',
      isAbbreviationInLabel: true,
    },
  },
  spreadRange: {
    component: RangeContainer,
    componentProps: {
      filterName: 'spreadRange',
      step: 1,
      decimals: 0,
    },
  },
  speedTypeList: {
    component: OneLevelListContainer,
    componentProps: {
      filterName: 'includedSpeedTypeIds',
      itemKeyPrefix: 'speedType',
      isAbbreviationInLabel: true,
    },
  },
  speedRange: {
    component: RangeContainer,
    componentProps: {
      filterName: 'speedRange',
      step: 0.01,
      decimals: 2,
    },
  },
};

const SectionsContainer = (props) => {
  const { items, isFetching } = useBondsFiltersContext();
  return (
    <Sections
      filtersTitleMapping={ filtersTitleMapping }
      filtersComponentsMapping={ filtersComponentsMapping }
      isFetching={ isFetching }
      items={ items.filter }
      { ...props }
    />
  );
};

export default SectionsContainer;
